import { FC, PropsWithChildren } from 'react';

type TermsAndConditionsLinkProps = {
  href: string;
  className?: string;
} & PropsWithChildren;

export const TermsAndConditionsLink: FC<TermsAndConditionsLinkProps> = ({
  href,
  children,
  className = 'rounded-lg font-bold text-brand-700 hover:text-brand-500 focus:underline focus:outline-none motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none',
}) => {
  return (
    <a href={href} target='_blank' className={className} rel='noreferrer'>
      {children}
    </a>
  );
};
